import { BlogIndexPage } from "@/components/blog/BlogIndexPage";
import type { BlogIndexView } from "@/utils/blog/types";

export interface PageProps {
  view: BlogIndexView;
}

export function Page({ view }: PageProps) {
  return <BlogIndexPage view={view} />;
}
